import ApiCaller from 'actions/ApiCaller';
import baseAjaxConfig from 'actions/BaseAjaxConfig';
import get from 'lodash/get';
export var BrandSearchToggleAction;
(function (BrandSearchToggleAction) {
    BrandSearchToggleAction["SHOW"] = "SHOW_BRAND_SEARCH";
    BrandSearchToggleAction["HIDE"] = "HIDE_BRAND_SEARCH";
})(BrandSearchToggleAction || (BrandSearchToggleAction = {}));
export function showBrandSearchAction() {
    return {
        type: BrandSearchToggleAction.SHOW
    };
}
export function hideBrandSearchAction() {
    return {
        type: BrandSearchToggleAction.HIDE
    };
}
export function getBrands(action) {
    const url = get(action, ['params', 'url']);
    if (!url) {
        return null;
    }
    const { actionRequestContext } = action.params;
    const apiPromise = ApiCaller.post(Object.assign(Object.assign({}, baseAjaxConfig), { pathname: `/api/${url}`, action: 'BRAND_SEARCH' }), actionRequestContext);
    return apiPromise;
}
